import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
import { SideBar } from '../../components/SideBar';
import { TopBar } from '../../components/TopBar';
import { colors } from '../../styling/colors';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/redux-store';
import { Settings } from './components/Settings';

export const StylePage = () => {
  const classes = useStyles();
  const loggedInUser = useSelector((state: RootState) => state.DATA_REDUCER.loggedInUser);

  return (
    // loggedInUser && (
    <Box className={classes.main} display="flex" flexDirection="column" p={4}>
      <Box mb={4}>
        <TopBar />
      </Box>
      <Grid container>
        <Grid item xs={12} sm={2} md={2}>
          <SideBar />
        </Grid>
        <Grid item xs={12} sm={10} md={10}>
          <Settings />
        </Grid>
      </Grid>
    </Box>
    // )
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    [theme.breakpoints.down('xs')]: {
      padding: '1rem'
    },
    backgroundColor: colors.background1,
    minHeight: '100vh'
  },
  contentContainer: {
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    }
  }
}));
